import {useLocation} from '@tanstack/react-router';

import {confusionMatrixCellIdQueryParam, finetunePageActiveTabQueryParam, Route, useQueryParam} from '~utils/routeUtil';

// import other query param constants, e.g. finetunePageActiveTab, curation flags, etc.

export type AnnotationUIContext =
  | 'database'
  | 'model-samples'
  | 'confusion-matrix'
  | 'model-test'
  | 'similarity-search'
  | 'improve-dataset'
  | 'model-finetune';

export function useAnnotationUIContext(): AnnotationUIContext | 'unknown' {
  const location = useLocation();
  const pathname = location.pathname;

  const [confusionMatrixCellId] = useQueryParam(confusionMatrixCellIdQueryParam);
  const [finetuneActiveTab] = useQueryParam(finetunePageActiveTabQueryParam);

  // 1) Similarity search route (/simsearch)
  if (pathname.startsWith('/simsearch')) {
    return 'similarity-search';
  }

  // 2) Archive / database views
  if (pathname.startsWith('/archive')) {
    return 'database';
  }

  // 3) Model samples route (/model/samples)
  if (pathname.startsWith('/model/samples')) {
    return 'model-samples';
  }

  // 4) Model finetune / model test pages
  if (pathname.startsWith('/model/finetune')) {
    // If confusion matrix cell id is present, this is "view images" from confusion matrix
    if (confusionMatrixCellId) {
      return 'confusion-matrix';
    }
    // If finetune active tab is test, this is "model test"
    if (finetuneActiveTab === 'test') {
      return 'model-test';
    }

    if (pathname.includes(Route.modelFinetuneImproveDataset)) {
      return 'improve-dataset';
    }

    return 'model-finetune';
  }

  return 'unknown';
}
